import axiosInstance from "../axiosInstance"


export const getUserCount=async()=>{

    try {
         const response =axiosInstance.get(`/auth/provider/counts/`)
         return response;
    } catch (error) {
         console.error("Error getting chat history:", error);
         throw error;
    }
 
 
 }